/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteAssistantMemorySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAssistantMemoryRequest = {
  /**
   * The assistant memory ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteAssistantMemorySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAssistantMemorySecurity$outboundSchema: z.ZodMiniType<
  DeleteAssistantMemorySecurity$Outbound,
  DeleteAssistantMemorySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAssistantMemorySecurityToJSON(
  deleteAssistantMemorySecurity: DeleteAssistantMemorySecurity,
): string {
  return JSON.stringify(
    DeleteAssistantMemorySecurity$outboundSchema.parse(
      deleteAssistantMemorySecurity,
    ),
  );
}

/** @internal */
export type DeleteAssistantMemoryRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteAssistantMemoryRequest$outboundSchema: z.ZodMiniType<
  DeleteAssistantMemoryRequest$Outbound,
  DeleteAssistantMemoryRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteAssistantMemoryRequestToJSON(
  deleteAssistantMemoryRequest: DeleteAssistantMemoryRequest,
): string {
  return JSON.stringify(
    DeleteAssistantMemoryRequest$outboundSchema.parse(
      deleteAssistantMemoryRequest,
    ),
  );
}
